export const emptyFilterModalWindowState = {
  loading: false,
  dispoCodes: [],
  statuses: [],
  surveyByList: [],
  lastModifiedByList: [],
  selectedDispoCodes: [],
  selectedStatuses: [],
  selectedSurveyByList: [],
  selectedLastModifiedByList: [],
  selectedSurveyDateFrom: null,
  selectedSurveyDateTo: null,
  selectedDateModifiedFrom: null,
  selectedDateModifiedTo: null,
};

export const initialFilterState = {
  dispositionCode: [],
  queueStatus: [],
  surveyDateFrom: null,
  surveyDateTo: null,
  dateModifiedFrom: null,
  dateModifiedTo: null,
  surveyBy: [],
  lastModifiedBy: [],
};